import React from 'react';
import { QueryClientProvider } from 'react-query';
import { QueryClientInstance } from '../Utils/queryClientInstance';
const ApisClientContext = /*#__PURE__*/React.createContext({});
export const ApisClientProvider = _ref => {
  let {
    children,
    httpClient
  } = _ref;
  const {
    values: existingValues
  } = React.useContext(ApisClientContext);
  if (existingValues != null && existingValues.httpClient && httpClient) {
    console.debug("Note that you're supplying a redundant httpClient via <ApiProvider />, previous httpClient was already supplied in the root provider");
  }
  if (!httpClient && !(existingValues != null && existingValues.httpClient)) {
    console.error('<ApiProvider> was not supplied');
  }
  if (existingValues != null && existingValues.httpClient) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(ApisClientContext.Provider, {
    value: {
      values: {
        httpClient: httpClient != null ? httpClient : existingValues.httpClient
      }
    }
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: QueryClientInstance.Instance.queryClient
  }, children));
};
export const useApisClientContext = () => {
  const {
    values
  } = React.useContext(ApisClientContext);
  if (!values) {
    throw new Error('<ApisClientProvider> was not initialize before calling "useApiContext", please add <ApisClientProvider> to your root component');
  }
  return values;
};
//# sourceMappingURL=ApisClientProvider.js.map